import { Component } from '@angular/core';

@Component({
  selector: 'app-arrow-forward-svg',
  standalone: true,
  template: `<svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99988 15.6155L9.06908 14.5616L3.25753 8.75009H15.6152V7.25014H3.25753L9.06908 1.43859L7.99988 0.384766L0.384534 8.00012L7.99988 15.6155Z"
      fill="#1C1D1F"
    />
  </svg> `,
})
export class ArrowForwardSvgComponent {}
